const LinkArrow = () => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7492 0.964326C11.7294 0.550581 11.3781 0.231146 10.9643 0.250848L4.22197 0.571913C3.80822 0.591615 3.48879 0.942993 3.50849 1.35674C3.52819 1.77048 3.87957 2.08992 4.29331 2.07022L10.2865 1.78482L10.5719 7.77803C10.5916 8.19178 10.943 8.51121 11.3567 8.49151C11.7705 8.47181 12.0899 8.12043 12.0702 7.70669L11.7492 0.964326ZM1 12L1.55496 12.5045L11.555 1.5045L11 0.999999L10.445 0.495495L0.445045 11.4955L1 12Z"
        fill="#F5F5F5"
      />
    </svg>
  );
};

export default LinkArrow;
